import React, { useEffect } from "react";
import { useParams } from "react-router";
import axios from "axios";
import $, { cssNumber } from "jquery";

import "../css/search.css";

import HeaderSearchBar from "../components/headerSearchBar";

export default function Search() {

    let { nome, type, price } = useParams();

    function lelivroBookOpen() {
        window.open(`https://lelivros.love/?x=0&y=0&s=${nome}`)
    }

    function doceroBookOpen() {
        window.open(`https://docero.com.br/show/?q=${nome}`)
    }

    useEffect(() => {
        if(type == "livros" || price == "paid") {
            axios.get(`https://www.googleapis.com/books/v1/volumes?q=${nome}`)
            .then(resp => {
                var data = resp.data;
                console.log(data);
                document.getElementById("bookAmount").innerText = `${data.totalItems} LIVROS ENCONTRADOS • MOSTRANDO ITENS MAIS RELEVANTES`;
    
                var books = data.items;

                document.getElementById("freeEbooksRedirect").href = `/procurar/ebooks/free/${nome}`
                document.getElementById("lelivrosButton").hidden = true;
                document.getElementById("doceroButton").hidden = true;
    
                console.log(books)
    
                books.forEach(book => {
                    console.log(book)
    
                    var volumeInfo = book.volumeInfo;
                    var saleInfo = book.saleInfo;
    
                    var saleState;
    
                    if(saleInfo.saleability == "FOR_SALE") {
                        saleState = `R$ ${saleInfo.listPrice.amount}`;
                    }
                    else {
                        saleState = "Fora de estoque"
                    }
    
                    if(volumeInfo.imageLinks) {
                        $("#generatedBooksHandler").append(`<div id="generatedBook"> <a href="/livros/${book.id}"> <div id="bookCoverHandler"><img src="${book.volumeInfo.imageLinks.thumbnail}" id="bookImage"/> </div> <h4 id="bookTitle">${volumeInfo.title}</h4> <h4 id="saleabilityDisplayer">${saleState}</h4> <p>${volumeInfo.authors[0]}</p> </a> </div>`)
                    }
                    else {
                        $("#generatedBooksHandler").append(`<div id="generatedBook"><div id="bookCoverHandler"><img src="https://i.ibb.co/S5yfWXR/unkw-book.png" id="bookImage"/> </div> <h4 id="bookTitle" >${volumeInfo.title}</h4> <h4 id="saleabilityDisplayer">${saleState}</h4> <p>${volumeInfo.authors[0]}</p> </div>`)
                    }
                })
            })
        }
        else {
            axios.get(`https://www.googleapis.com/books/v1/volumes?q=${nome}&filter=free-ebooks&key=AIzaSyDQSLPH0T1iL8ToeHrYLBtR_F9auhtRq3s`)
            .then(resp => {
                document.getElementById("freeEbookButton").hidden = true;
                var data = resp.data;
                console.log(data);
                document.getElementById("bookAmount").innerText = `${data.totalItems} EBOOKS GRATUITOS • MOSTRANDO ITENS MAIS RELEVANTES`;

                var books = data.items;
    
                books.forEach(book => {
                    console.log(book)
    
                    var volumeInfo = book.volumeInfo;
                    var saleInfo = book.saleInfo;

                    var saleState = "Gratuito";

                    var count = 35;
                    volumeInfo.title = volumeInfo.title.slice(0, count) + (volumeInfo.title.length > count ? "..." : "");

                    var infoArray = {
                        "id":book.id,
                        "thumblink":book.volumeInfo.imageLinks.thumbnail,
                        "title":volumeInfo.title,
                        "saleState":saleState,
                        "authors":volumeInfo.authors
                    }

                    if(volumeInfo.authors == undefined) volumeInfo.authors = "Autor(es) desconhecido(s)"

                        
                    if(volumeInfo.imageLinks) {
                        $("#generatedBooksHandler").append(`<div id="generatedBook"> <a href="/livros/${book.id}"> <div id="bookCoverHandler"><img src="${book.volumeInfo.imageLinks.thumbnail}" id="bookImage"/> </div> <h4 id="bookTitle">${volumeInfo.title}</h4> <h4 id="saleabilityDisplayer">${saleState}</h4> <p>${volumeInfo.authors}</p> </a> </div>`)
                    }
                    else {
                        $("#generatedBooksHandler").append(`<div id="generatedBook"><div id="bookCoverHandler"><img src="https://i.ibb.co/S5yfWXR/unkw-book.png" id="bookImage"/> </div> <h4 id="bookTitle" >${volumeInfo.title}</h4> <h4 id="saleabilityDisplayer">${saleState}</h4> <p>${volumeInfo.authors}</p> </div>`)
                    }

                    document.getElementById("lelivrosRedirect").href = `https://lelivros.love/?x=0&y=0&s=${nome}`
                    document.getElementById("doceroRedirect").href = `https://docero.com.br/show/?q=${nome}`

                })
            })
        }
    }, [])

    return (
        <div className="app" id="searchAppDiv">
            <HeaderSearchBar />

            <div className="searchTitlePreview">
                <h1>Resultados para "{nome}"</h1>
                <h3 id="bookAmount"></h3>
            </div>

            <div id="eBookButtonsHandler">
                <a id="freeEbooksRedirect">
                    <button id="freeEbookButton">Ver eBooks grátis</button>
                </a>
            </div>

            <div id="eBookStoreButtonsHolder">
                <div id="eBookButtonsHandler">
                    <a id="lelivrosRedirect">
                        <button id="lelivrosButton">Ver eBooks em Le Livros</button>
                    </a>
                </div>

                <div id="eBookButtonsHandler">
                    <a id="doceroRedirect">
                        <button id="doceroButton">Ver eBooks em Docero</button>
                    </a>
                </div>
            </div>

            <div id="generatedBooksHandler" />
        </div>
    )
}